export default __webpack_public_path__ + "static/media/spade-icon.aa5683d3.svg";